export const stripHtmlTags = (html: string): string => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

export const stripHtmlTagsRemove = (html: string): string => {
  return html.replace(/<\/?[^>]+(>|$)/g, '');
};

// Vrai si le HTML contient du texte visible (un éditeur vidé laisse souvent `<p><br></p>`)
export const hasHtmlText = (html: string | null | undefined): boolean => {
  if (!html) return false;
  return (
    stripHtmlTagsRemove(html)
      .replace(/&nbsp;/g, ' ')
      .trim().length > 0
  );
};

export function truncateText(text: string, maxLength: number): string {
  const cleanText = stripHtmlTags(text);
  return cleanText.length > maxLength ? cleanText.substring(0, maxLength) + '...' : cleanText;
}
